<script setup>
  import { reactive, ref, watch,onMounted } from 'vue'
  import { storeToRefs } from 'pinia'
  import NavigationDataService from './services/NavigationDataService'
  import LocalizationDataService from '@/translations/LocalizationDataService'
  import ThlSlideMenuService from "@/services/ThlSlideMenuService"
  import { useConfigStore } from "@/store/config"
  import NavIterator from '@/components/NavIterator'
  import SubsiteView from '@/components/SubsiteView'

  const store = useConfigStore()
  const { slideViewActive } = storeToRefs(store)
  // For controlling visibilty of certain element
  const state = reactive({})
  // Nav childs template refs
  const itemsRef = ref([])
  const curLocale = ref("fi")
  const layoutId = ref(null)
  const navItem = ref(null)
  const navLevel = ref(1)
  const navTree = ref(null)
  const navElem = ref({
    link: {
      classes: "parent-menu-link-text has-btn"
    },
    button : {
      classes: "child-icon",
      ariaText: {
        submenu: LocalizationDataService.getText("section-sub-menu")
      }
    }
  })

  // Project pages
  const isInProjectPage = ref(false)

  const toggleChildren = (index) => {
    navTree.value[index].ariaExpanded = navTree.value[index].ariaExpanded === 'false' ? 'true' : 'false'
  }


  onMounted(() => {
    // Get current layout ID
    const app = document.getElementById('mobile-navigation')
    if (app) {
      if (app.dataset?.layoutId) layoutId.value = app.dataset.layoutId
      if (!!layoutId.value) {
        // Add Current layout ID to store
        store.setCurrentLayoutId(layoutId.value)

        // Set current locale
        curLocale.value = LocalizationDataService.getLocale()

        // Get navItems
        NavigationDataService.getAll(layoutId.value)
            .then((response) => {
              if (response.data !== "") {
                navItem.value = response.data

                // Remove hidden pages
                if (!!navItem.value.children)  {
                  navTree.value = navItem.value.children.filter(e => !e.isHidden)
                }

                // Go thru parents and check if nav items should be shown in subsite view
                NavigationDataService.findParents(navItem.value.children)

                // Check if project page nav item should should be shown in normal view
                if (store.getIsInProjectPages) {
                  if (
                      (store.getParents.length === 2 && (!store.currentNavItem.isHidden || !store.currentNavItem.hasChildren)) ||
                      (store.getParents.length > 2 && !store.getParentItems[store.getParents.length - 3].isHidden)
                  ) {
                      // Store layoutID
                      store.setProjectPageLayoutId(store.currentNavItem.navItemId)
                      // Show in normal navigation
                      store.setSlideViewActive(false)
                  }
                }

                // Enhance navTree elements
                navTree.value.forEach(nav => {
                  const attrs = {
                    link: {
                      classes: "parent-menu-link-text has-btn"
                    },
                    button : {
                      classes: "child-icon",
                      ariaText: {
                        submenu: LocalizationDataService.getText("section-sub-menu")
                      }
                    }
                  }

                  // Check if is slide menu page
                  const isThemePage = ThlSlideMenuService.isThemePage(nav.name)
                  const isTopicPage = ThlSlideMenuService.isTopicPage(nav.name)

                  Object.assign(nav, { useSlideMenu : isThemePage })

                  // Add css classes
                  Object.assign(nav, { attributes : attrs })
                  Object.assign(nav, { li: "parent-menu-item "})

                  if (nav.isChildSelected)  {
                    Object.assign(nav, { ariaExpanded: "true"})
                    nav.li += " currentpage open "
                  } else {
                    Object.assign(nav, { ariaExpanded: "false"})
                  }

                  Object.assign(nav, { ariaCurrent: null})

                  // if nav is selected
                  if (nav.navItemId === layoutId.value) {
                    nav.li += " currentpage currentlast open"
                    nav.ariaCurrent = "page"
                  }

                  // Add locale prefix to link urls
                  if ( curLocale.value !== "fi") nav.friendlyUrl = `/${curLocale.value}${nav.friendlyUrl}`


                })
              }
            })
            .catch((e) => {
              console.log(e)
            })
      }
    }
  })

  watch(slideViewActive, () => {

    if (!store.isSlideViewActive) {
      itemsRef.value.forEach(nav => {
        nav.style.left = "-1000px";
      })
      // Do animation
      setTimeout(() => {
        itemsRef.value.forEach(nav => {
          nav.style.left = "0";
        })
      }, 100)
      // Move focus
      setTimeout(() => {

        const ul = document.querySelector('#mobile-menu')
        if (ul) {
          const li = ul.querySelector(`[data-nav-item="${store.getSlideLayoutId}"]`)
          if (li) {
            const button = li.querySelectorAll('a')[0]
            if (button) {
              button.focus();
            }
          }
        }
      }, 1000)
    }
  })
</script>
<template>
  <div class="mobile-navigation-wrapper">
    <ul id="mobile-menu" aria-labelledby="mobile-nav-toggle" class="parent-menu">
        <li v-if="!!navItem && !navItem.isHidden" v-show="!store.isSlideViewActive" :class="navChild.li" :data-nav-item="navChild.navItemId" v-for="(navChild, index) in navTree" :key="navChild.navItemId" ref="itemsRef">
          <a
              :href="navChild.friendlyUrl"
              :aria-current="navChild.ariaCurrent"
              :class="navChild.attributes.link.classes"
          >
            <span v-html="navChild.name"></span>
          </a>
         <template v-if="navChild.hasChildren">
           <button
               :class="navChild.attributes.button.classes"
               :aria-expanded="navChild.ariaExpanded"
               @click="toggleChildren(index)"
           >
              <span class="sr-only">{{ navChild.name }} {{ navChild.attributes.button.ariaText.submenu }}</span>
           </button>

           <NavIterator
               :layout-id="navChild.navItemId"
               :level="navLevel + 1"
               v-if="navTree[index].ariaExpanded === 'true'"
               :curLayoutId="layoutId"
               :useSlideMenu="navChild.useSlideMenu"
               :parentIsActive="navChild.isChildSelected"
           />
          </template>
        </li>

        <SubsiteView
            v-if="store.isSlideViewActive"
        />

    </ul>
  </div>
</template>
